var map = {
	"./demos/basic/index.ts": 5382,
	"./demos/close/index.ts": 93453,
	"./demos/duration/index.ts": 11694,
	"./demos/events/index.ts": 84633,
	"./demos/hideClose/index.ts": 22196,
	"./demos/icon/index.ts": 80850,
	"./demos/position/index.ts": 80425,
	"./demos/types/index.ts": 30896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98770;